import React from 'react';
import PropTypes from 'prop-types';

// Components
import {
    EmptyStateContainer,
    RenderEmptyStateContent
} from '../../../../../../../../components/Table/components/TableEmptyState';
import { NewPredicateButton } from './NewPredicateButton';

// Context
import { PredicateWrapper } from './PredicateWrapper';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../state/criteria/hooks/useCriteriaStorePredicate';

export const PredicateChildren = ({ uuid, nestedLevel = 0 }) => {
    const element = useCriteriaStorePredicate(uuid);

    if (!element) return null;
    return nestedLevel === 0 && element?.predicates?.length === 0 ? (
        <EmptyStateContainer>
            {RenderEmptyStateContent({
                labelfontsize: 600,
                imageSize: 9,
                customlabel: (
                    <>
                        No predicates have been added yet. <br />
                        <br />
                        <NewPredicateButton stringOnly>Click here</NewPredicateButton> to add the first predicate.
                    </>
                )
            })}
        </EmptyStateContainer>
    ) : (
        <PredicateWrapper parentPredicateUuid={uuid} predicateUuids={element?.predicates} nestedLevel={nestedLevel} />
    );
};

export default PredicateChildren;

PredicateChildren.propTypes = {
    uuid: PropTypes.string,
    nestedLevel: PropTypes.number
};
